module.exports = __webpack_public_path__ + "static/media/animal-03.bf290eae.mp3";